import React from 'react';
import Misc from '../base/components/Misc';
import { setWindowTitle } from '../base/plumbing/Crud';
import DataStore from '../base/plumbing/DataStore';
import { toTitleCase } from '../base/utils/miscutils';
import C from '../C';
import ActionMan from '../plumbing/ActionMan';
import ListItems from './ListItems';





function LineItemPage() {
	const type = C.TYPES.LineItem;
	setWindowTitle(type);

	const blocked = Misc.CheckAccess({can: 'editAdvert'});
	if (blocked) return blocked;

	const path = DataStore.getValue(['location','path']);
	const itemId = path[1];
	if ( ! itemId) {		
		return <ListItems type={type} createWith={[C.TYPES.Advert]} />;
	}
	const pvItem = ActionMan.getDataItem({type, id:itemId, status:C.KStatus.DRAFT});
	if ( ! pvItem.value) {		
		return (<div><h1>{toTitleCase(type)}: {itemId}</h1><Misc.Loading /></div>);
	}
	const item = pvItem.value;
	return (
		<div className="">
			<h1>{toTitleCase(type)}: {item.name || itemId}</h1>
			<EditLineItem item={item} />
		</div>
	);
} // ./AgencyPage


function EditLineItem({item}) {
	// render
	return (
		<div>
			{JSON.stringify(item)}
		</div>
	);
}


export default LineItemPage;
